import type { IconData } from '@stacksjs/iconify-core'

export const ipadTabletScreenFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 4.5c-7.403 0-12.592.239-15.857.466S2.281 7.66 1.991 10.96C1.742 13.794 1.5 18.074 1.5 24s.242 10.206.491 13.041c.29 3.3 2.887 5.765 6.152 5.993c3.265.227 8.454.466 15.857.466s12.592-.239 15.857-.466s5.862-2.693 6.152-5.993c.249-2.835.491-7.115.491-13.041s-.242-10.206-.491-13.041c-.29-3.3-2.887-5.765-6.152-5.993C36.592 4.74 31.403 4.5 24 4.5\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M13 36a2 2 0 0 1 2-2h18a2 2 0 1 1 0 4H15a2 2 0 0 1-2-2\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default ipadTabletScreenFlat
